// import { TOOGLE_NAVIGATION } from "../actions/types";
import { createSlice } from '@reduxjs/toolkit';


const initialState = {
  navigationCollapsed: true,
};

const drawerSlice = createSlice({
  name: 'drawer',
  initialState,
  reducers: {
    toggleNavigation(state) {
      state.navigationCollapsed = !state.navigationCollapsed;
    },
  },
});

export const { toggleNavigation } = drawerSlice.actions;

export default drawerSlice.reducer;
